import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import AppIcon from '@/components/common/app-icon/AppIcon.vue';
import CustomTooltip from '@/components/common/tooltip/CustomTooltip.vue';
import type { IconName, IconSize } from '@/models/icon-types';


export default /*@__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    iconName: {},
    tooltipMessage: {},
    iconSize: {},
    iconClass: {}
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const iconSize = computed(() => props.iconSize ?? 'body-xl');
const iconClass = computed(() => props.iconClass ?? 'color-lighter');

const emit = __emit;

function onClick() {
  emit('click');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomTooltip, {
    message: _ctx.tooltipMessage,
    position: "bottom",
    size: "small"
  }, {
    default: _withCtx(() => [
      _createVNode(AppIcon, {
        name: _ctx.iconName,
        size: iconSize.value,
        "class-name": iconClass.value,
        onClick: onClick,
        clickable: true
      }, null, 8, ["name", "size", "class-name"])
    ]),
    _: 1
  }, 8, ["message"]))
}
}

})